var map = {
	"./company": 1,
	"./company.png": 1,
	"./hero-datafinder": 2,
	"./hero-datafinder.svg": 2,
	"./icon-time": 3,
	"./icon-time.png": 3,
	"./logo": 4,
	"./logo.png": 4,
	"./search-icon": 5,
	"./search-icon.svg": 5,
	"./sort_asc": 6,
	"./sort_asc.png": 6,
	"./sort_asc_disabled": 7,
	"./sort_asc_disabled.png": 7,
	"./sort_both": 8,
	"./sort_both.png": 8,
	"./sort_desc": 9,
	"./sort_desc.png": 9,
	"./sort_desc_disabled": 10,
	"./sort_desc_disabled.png": 10
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13;